var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "data-testid": "collapse-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#collapse_svg__filter0_d_12337_167135)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M4.75 2.195h14.5c1.135 0 2.055.92 2.055 2.055v16.5c0 1.135-.92 2.055-2.055 2.055H4.75a2.055 2.055 0 0 1-2.055-2.055V4.25c0-1.135.92-2.055 2.055-2.055Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#collapse_svg__filter1_d_12337_167135)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M8.626 12.29 12 15.07m0 0 3.374-2.78M12 15.07V6.496"
  }))));
};
export default SvgCollapse;